import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder", "type", "maxlength", "disabled", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-field", {disabled: _ctx.disabled}])
  }, [
    (_ctx.prefixIcon)
      ? (_openBlock(), _createBlock(_component_icon, {
          key: 0,
          name: _ctx.prefixIcon
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      class: "input",
      autocomplete: "off",
      placeholder: _ctx.placeholder,
      type: _ctx.type,
      maxlength: _ctx.maxLength,
      disabled: _ctx.disabled,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
      value: _ctx.modelValue
    }, null, 40, _hoisted_1),
    (_ctx.suffixIcon)
      ? (_openBlock(), _createBlock(_component_icon, {
          key: 1,
          name: _ctx.suffixIcon
        }, null, 8, ["name"]))
      : _createCommentVNode("", true)
  ], 2))
}